// @flow

import { hpfetch } from '../util';

export const postAppVersion = () => {
  hpfetch('client-version/web/', {
    method: 'POST',
    body: JSON.stringify({
      version:
        process.env.REACT_APP_VERSION ||
        process.env.REACT_APP_COMMIT_HASH ||
        'N/A (development)',
    }),
  });
};
